import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";
import { ReplacedBy } from "../../../types/sale.type";
import { formatReplaceMetres } from "../data";

interface ReplaceFlagWarningProps {
  replacedBy?: ReplacedBy | null;
}

/**
 * Shown in the approve-cancel dialog. A replace moves the old bill to pending_cancel,
 * so approving it is finance's last chance to notice the salesperson replaced the
 * wrong shop's bill. Warn-only: approval stays possible.
 *
 * NEAR_OTHER_SHOP gets the loud red block with the fix steps; FAR a milder note.
 * Every other flag (and none) renders nothing.
 */
export default function ReplaceFlagWarning({
  replacedBy,
}: ReplaceFlagWarningProps) {
  if (!replacedBy) return null;
  const billNo = replacedBy.transaction_no ?? "-";

  if (replacedBy.replace_gps_flag === "NEAR_OTHER_SHOP") {
    return (
      <Alert severity="error" sx={{ mt: 2 }}>
        <AlertTitle>บิลแทนอาจออกผิดร้าน</AlertTitle>
        <Typography variant="body2">
          บิลแทน {billNo} ออกให้ร้าน {replacedBy.customer_name ?? "-"} (
          {replacedBy.customer_code ?? "-"}) แต่ตอนออกบิล เซลล์อยู่ใกล้ร้าน{" "}
          {replacedBy.replace_nearest_customer_code ?? "-"} (~
          {formatReplaceMetres(replacedBy.replace_nearest_distance_m)} ม.)
          มากกว่า — กรุณาตรวจกับเซลล์ก่อนอนุมัติ
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          ถ้าผิดร้าน: ยกเลิกบิลแทน → คืนสถานะบิลเดิม (master) →
          ให้เซลล์ออกบิลให้ร้านที่ถูกภายในวันนี้
        </Typography>
      </Alert>
    );
  }

  if (replacedBy.replace_gps_flag === "FAR") {
    return (
      <Alert severity="warning" sx={{ mt: 2 }}>
        บิลแทน {billNo} ออกตอนเซลล์อยู่ห่างร้าน{" "}
        {replacedBy.customer_name ?? replacedBy.customer_code ?? "-"} ประมาณ{" "}
        {formatReplaceMetres(replacedBy.replace_distance_m)} ม.
        ควรตรวจกับเซลล์ก่อนอนุมัติ
      </Alert>
    );
  }

  return null;
}
